import router from'../router'
import store from'../store'

export const pimgSize=10;//pimg10M
export const maximgnum=12;//发布帖子最多上传x个图片
export const maxvideonum=8;//发布帖子最多上传x视频
export const maxvideoarea=150;//发布帖子最多上传视频大小多少M
export const forumImgGongge =3;//帖子几宫格，九宫格就是3


 
export const messageSocketUrl='wss://www.holylightbbs.com/prod-api/websocket/message/';//消息socket链接
// export const messageSocketUrl='ws://43.135.72.41/prod-api/websocket/message/';//消息socket链接
// export const messageSocketUrl='ws://127.0.0.1:8099/websocket/message/';//消息socket链接

//常用外部链接
export const lianjie=['https://anshuoxie.com/'
    ,'http://pan.dcfofa.net/#s/8PmG6D2g'
    ,'https://weibo.com/xieanshuo?is_all=1'
    ,'https://www.youtube.com/channel/UCqHIWhPEVSJWZCvvYGvbzTw'
    ,'https://holybless.com/category/media/music']


//正则
export const pwdReg=/^(\w){6,20}$/
export const unameReg=/^[\u4E00-\u9FA5A-Za-z0-9]{2,16}$/
export const emailReg=/^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/
//export const mobileReg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/
export const mobileReg=/^(\d){7,11}$/
export const rnameReg=/^[\u4E00-\u9FA5]{2,4}$/




export const getSessionid=function (){
       let sessionId=parseInt(Math.round(Math.random()*100000000))+""+parseInt(Math.round(Math.random()*10000));
       return  sessionId;
}
//手机区号
export const qcountryMobileLi=[{name:"中国",value:"86"},{name:"中国香港",value:"00852"},{name:"中国澳门",value:"00853"}
,{name:"中国台湾",value:"00886"},{name:"美国",value:"001"},{name:"加拿大",value:"001"},{name:"巴西",value:"0055"},
        {name:"马拉西亚",value:"0060"},{name:"澳洲",value:"0061"},{name:"日本",value:"0081"},{name:"韩国",value:"0082"},
        {name:"新加坡",value:"0065"},{name:"英国",value:"0044"},{name:"法国",value:"0033"},{name:"俄罗斯",value:"007"},
        {name:"印度",value:"0091"},{name:"泰国",value:"0066"},{name:"德国",value:"0049"},{name:"意大利",value:"0039"},
        {name:"西班牙",value:"0034"},{name:"印尼",value:"0062"},{name:"柬埔寨",value:"00855"},{name:"缅甸",value:"0095"},
        {name:"文莱",value:"00673"},{name:"菲律宾",value:"0063"},{name:"越南",value:"0084"},{name:"老挝",value:"00856"},
        {name:"波兰",value:"0048"} ]


export const dealResult=function(obj){
    if(obj.status==-1){
        localStorage.removeItem("uid");
        localStorage.removeItem("token");
        localStorage.removeItem("autologin");

        delCookie("uid");
        delCookie("token");


        router.replace("Login");
    }if(obj.status==-100){
        sessionStorage.systip=obj.msg;
        sessionStorage.removeItem("tol");
        router.replace("Tip");
    }
    if(obj.status==-2){
        sessionStorage.systip=obj.msg;
        sessionStorage.removeItem("tol");
        router.replace("Tip");
    }

}
export const logout=function(){
    store.dispatch('saveLogininfo','');

    localStorage.removeItem("uid");
    localStorage.removeItem("token");
    localStorage.removeItem("autologin");

    sessionStorage.removeItem("uid");
    sessionStorage.removeItem("token");

    delCookie("uid");
    delCookie("token");

    setTimeout(()=>{
        router.replace("Login");
    },1000)

}


export const isWeb=function(){
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if( flag){
        return false;
    }
    return true;

}


export const getWindowWidth=function(){

    let w=window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    return w;
}

export const  getCookie=function(c_name){
    if (document.cookie.length>0){
       let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1){
            c_start=c_start + c_name.length+1
           let  c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
            return unescape(document.cookie.substring(c_start,c_end))
        }
    }
    return undefined;
}



export const  setCookie=function(c_name, value, expiredays){

    let exdate=new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie=c_name+ "=" + escape(value) + ((expiredays==null) ? "" : ";expires="+exdate.toGMTString());

}


export const delCookie=function(name) {

    let exp = new Date();

    exp.setTime(exp.getTime() - 1);

    let cval=getCookie(name);

    if(cval!=null) document.cookie= name + "="+cval+";expires="+exp.toGMTString();

}